import React, { useState, useEffect } from "react";
import { Navbar, Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  detectCurrencyByIP,
  getSupportedCurrencies,
} from "../services/services";
import IndiaImg from "./assets/img/India.png";
import UsaImg from "./assets/img/usa.png";
import FranceImg from "./assets/img/france.png";
import JapanImg from "./assets/img/japan.png";
import GermanyImg from "./assets/img/germany.png";
import Logo from "./assets/img/logo.png";

const Header = () => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState("India");
  const [selectedLanguage, setSelectedLanguage] = useState("English");
  const [selectedCurrency, setSelectedCurrency] = useState(
    localStorage.getItem("preferredCurrency") || ""
  );
  const [selectedFlag, setSelectedFlag] = useState(IndiaImg);
  const countries = [
    { name: "India", flag: IndiaImg },
    { name: "USA", flag: UsaImg },
    { name: "France", flag: FranceImg },
    { name: "Japan", flag: JapanImg },
    { name: "Germany", flag: GermanyImg },
  ];
  const [currencies, setCurrencies] = useState({});

  useEffect(() => {
    const fetchCurrencies = async () => {
      const result = await getSupportedCurrencies();
      setCurrencies(result);
    };
    fetchCurrencies();
  }, []);

  const languages = ["English", "French", "Japanese", "German", "Hindi"];
  // const currencies = ["INR", "USD", "EUR", "JPY", "GBP", "MYR"];

  // useEffect(() => {
  //   const detectAndSetCurrency = async () => {
  //     if (!selectedCurrency) {
  //       const detected = await detectCurrencyByIP();
  //       localStorage.setItem("preferredCurrency", detected);
  //       setSelectedCurrency(detected);
  //        const event = new CustomEvent("currencyChanged");
  //        window.dispatchEvent(event);
  //     }
  //   };
  //   detectAndSetCurrency();

  //   const handleCurrencyChange = (e) => {
  //     setSelectedCurrency(e.detail);
  //   };
  //   window.addEventListener("currencyChanged", handleCurrencyChange);

  //   return () => {
  //     window.removeEventListener("currencyChanged", handleCurrencyChange);
  //   };
  // }, [selectedCurrency]);

  useEffect(() => {
    const detectAndSetCurrency = async () => {
      if (!localStorage.getItem("preferredCurrency")) {
        const detected = await detectCurrencyByIP();
        localStorage.setItem("preferredCurrency", detected);
        setSelectedCurrency(detected);
        const event = new CustomEvent("currencyChanged", { detail: detected });
        window.dispatchEvent(event);
      } else {
        setSelectedCurrency(localStorage.getItem("preferredCurrency"));
      }
    };

    detectAndSetCurrency();

    const handleCurrencyChange = (e) => {
      setSelectedCurrency(e.detail);
    };

    window.addEventListener("currencyChanged", handleCurrencyChange);

    return () => {
      window.removeEventListener("currencyChanged", handleCurrencyChange);
    };
  }, []);

  const handleCurrencyChange = (newCurrency) => {
    setSelectedCurrency(newCurrency);
    localStorage.setItem("preferredCurrency", newCurrency);

    const event = new CustomEvent("currencyChanged", { detail: newCurrency });
    window.dispatchEvent(event);
  };

  return (
    <div className="headerWrap">
      <header>
        <div className="container-fluid">
          <div className="row align-items-center">
            <div className="col-md-12">
              <Navbar expand="md">
                {/* Logo */}
                <Navbar.Brand as={Link} to="/">
                  <img src={Logo} className="img-fluid" alt="" />
                </Navbar.Brand>

                <Navbar.Toggle aria-controls="navbar-nav" />

                <Navbar.Collapse id="navbar-nav">
                  <Nav className="me-auto">
                    <Nav.Link as={Link} to="/#flightBanner">
                      Flights
                    </Nav.Link>
                    <Nav.Link as={Link} to="/ComingSoon">
                      Hotels
                    </Nav.Link>
                    {/* <Nav.Link as={Link} to="/ComingSoon">
                      Holidays
                    </Nav.Link> */}
                    <Nav.Link as={Link} to="/AboutUs">
                      About
                    </Nav.Link>
                    <Nav.Link as={Link} to="/ContactUs">
                      Contact
                    </Nav.Link>
                    <Nav.Link as={Link} to="/B2BPortal" style={{fontWeight: 'bold', color: '#0dcaf0'}}>
                      {/* Login / Register B2B */}
                    </Nav.Link>
                  </Nav>
                  <div className="rightNav">
                    <div className="dropdownContainer">
                      <div
                        className="langWrap"
                        onClick={() => setShowDropdown(!showDropdown)}
                      >
                        <div className="dataWrap">
                          <p>
                            Currency: {selectedCurrency}{" "}
                            <svg
                              width="11"
                              height="6"
                              viewBox="0 0 13 8"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M0.75 1.20898L6.33206 6.79105L11.9141 1.20898"
                                stroke="black"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </p>
                        </div>
                      </div>

                      {showDropdown && (
                        <div className="dropdown">
                          <div className="dropdownSection">
                            <label>Currency</label>
                            <select
                              value={selectedCurrency}
                              onChange={(e) =>
                                handleCurrencyChange(e.target.value)
                              }
                            >
                              {Object.entries(currencies).map(
                                ([code, name]) => (
                                  <option key={code} value={code}>
                                    {code} - {name}
                                  </option>
                                )
                              )}
                            </select>
                          </div>

                          <button
                            className="closeBtn"
                            onClick={() => setShowDropdown(false)}
                          >
                            Save & Close
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </Navbar.Collapse>

                <div className="rightNav forMobRtNav">
                  <div className="dropdownContainer">
                    <div
                      className="langWrap"
                      onClick={() => setShowDropdown(!showDropdown)}
                    >
                      <div className="dataWrap">
                        <p>
                          Currency: {selectedCurrency}{" "}
                          <svg
                            width="11"
                            height="6"
                            viewBox="0 0 13 8"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M0.75 1.20898L6.33206 6.79105L11.9141 1.20898"
                              stroke="black"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </p>
                      </div>
                    </div>

                    {showDropdown && (
                      <div className="dropdown">
                        <div className="dropdownSection">
                          <label>Currency</label>
                          <select
                            value={selectedCurrency}
                            onChange={(e) =>
                              handleCurrencyChange(e.target.value)
                            }
                          >
                            {Object.entries(currencies).map(([code, name]) => (
                              <option key={code} value={code}>
                                {code} - {name}
                              </option>
                            ))}
                          </select>
                        </div>

                        <button
                          className="closeBtn"
                          onClick={() => setShowDropdown(false)}
                        >
                          Save & Close
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </Navbar>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
};

export default Header;
